// Zentrale CSS-Datei zuerst importieren – Vite bündelt sie aus dem JS-Graph
// und schreibt sie als Resources/Public/css/main.min.css raus.
import '../css/main.css';

import { initMenu } from './menu';
import { initSidebar } from './sidebar';
import { initSliders } from './slider';
import { initVideoPlayer } from './video';
import './vue';
import { initLightbox } from './lightbox';
import { initGmaps } from './gmaps';
import { initIframeResizer } from './iframeresizer';
import { initScroller } from './scroller';
import { initPasswordToggle } from './password-toggle';
import { initTextTruncation } from './text-truncation';

// Alle DOM-abhängigen Initialisierungen laufen erst nach dem DOM-Ready-Event,
// damit die Module unabhängig von der Reihenfolge im <head>/<body> greifen.
function bootstrap() {
  initMenu();
  initSidebar();
  initSliders();
  initVideoPlayer();
  initLightbox();
  initGmaps();
  initIframeResizer();
  initScroller();
  initPasswordToggle();
  initTextTruncation();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
